import React from 'react'
import { svg, SvgType } from '@components/atoms/icons/svg'
import { grey } from '@mui/material/colors'
import { useAppSelector } from '@redux/index'

interface PropsType {
	fill?: string
	strokeColor?: string
	size?: number
}

export const LargeCloseIcon = (props: PropsType) => {
	// redux state
	const backgroundColor: string = useAppSelector(state => state.config.backgroundColor)

	const closeIcon: SvgType[] = svg.filter((anIcon: SvgType) => anIcon.name === 'close')
	const CloseIconComponent: SvgType['icon'] = closeIcon[0]['icon']

	const fill: string = props.fill ?? grey[800]
	const size: number = props.size ?? 90
	const strokeColor: string = props.strokeColor ?? backgroundColor

	return (
		<CloseIconComponent
			fill={fill}
			width={size}
			height={size}
			stroke={strokeColor}
			strokeWidth="1.6px"
		/>
	)
}
